/**
 * @generated SignedSource<<4d967f0469d164d717ff86c084e17e3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OnboardingStatementInputObject = {
  sourceId: string;
  uploads: ReadonlyArray<UploadInputObject>;
};
export type UploadInputObject = {
  id: string;
  metadata: UploadMetadataInputObject;
  storage: string;
};
export type UploadMetadataInputObject = {
  filename: string;
  mimeType: string;
  size: number;
};
export type statementUploader_UploadMutation$variables = {
  input: OnboardingStatementInputObject;
  token?: string | null | undefined;
};
export type statementUploader_UploadMutation$data = {
  readonly leadStatementUpload: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly lead: {
      readonly completenessScore: number;
    } | null | undefined;
  } | null | undefined;
};
export type statementUploader_UploadMutation = {
  response: statementUploader_UploadMutation$data;
  variables: statementUploader_UploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v2 = [
  {
    "kind": "Variable",
    "name": "onboardingStatementInput",
    "variableName": "input"
  },
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completenessScore",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "statementUploader_UploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "LeadStatementUploadMutationPayload",
        "kind": "LinkedField",
        "name": "leadStatementUpload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "statementUploader_UploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "LeadStatementUploadMutationPayload",
        "kind": "LinkedField",
        "name": "leadStatementUpload",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce2bcf587301611b20ee416cb31a362f",
    "id": null,
    "metadata": {},
    "name": "statementUploader_UploadMutation",
    "operationKind": "mutation",
    "text": "mutation statementUploader_UploadMutation(\n  $token: String\n  $input: OnboardingStatementInputObject!\n) {\n  leadStatementUpload(token: $token, onboardingStatementInput: $input) {\n    lead {\n      completenessScore\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d96fcff165d276b4cae9b623ba0d321b";

export default node;
